module.exports = __webpack_public_path__ + "static/media/corner-dark.cf0a480e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/corner-dark.svg
// module id = 840
// module chunks = 7